import formatMoney from './formatMoney';

export default function attachNamesAndPrices(orders, products) {
  return orders.map((order) => {
    const product = products.find(
      (singleProduct) => singleProduct.id === order.id
    );
    return {
      ...order,
      name: product.name,
      thumbnail: product.image[0].asset.url,
      price: formatMoney(product.price),
    };
  });
}
